import { soyshareApi } from '../../../../../services/api'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getMemberTypesDropdown: build.query({
      query: (params) => ({ url: '/member-types/dropdown/list', params }),
      providesTags: ['member-types-dropdown']
    })
  })
})

export const { useGetMemberTypesDropdownQuery } = api
